import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@rtkwlf/pro-solid-svg-icons/faDownload';
import { faFileExport } from '@rtkwlf/pro-solid-svg-icons/faFileExport';
import { useTranslation } from 'react-i18next';

import type { ButtonProps } from '@packages/fenrir/components';
import {
  Button,
  DropdownMenu,
  DropdownMenuItem,
} from '@packages/fenrir/components';

export interface ExportActionProps {
  onExportAll: () => void;
  onExportFiltered?: () => void;
  isExporting?: boolean;
}

export const ExportAction: React.FC<ExportActionProps> = ({
  onExportAll,
  onExportFiltered,
  isExporting = false,
}) => {
  const { t } = useTranslation('ui');

  const TriggerButton = (props: ButtonProps) => {
    return (
      <Button
        sx={{ mt: 0.5 }}
        size="small"
        variant="text"
        loading={isExporting}
        loadingPosition="start"
        startIcon={<FontAwesomeIcon icon={faDownload} />}
        {...props}
      >
        {t('export.title')}
      </Button>
    );
  };

  return (
    <DropdownMenu
      menuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      }}
      renderTriggerButton={(params) => <TriggerButton {...params} />}
    >
      <DropdownMenuItem
        label={t('export.allRows')}
        icon={faFileExport}
        onClick={onExportAll}
      />
      <DropdownMenuItem
        label={t('export.filteredRows')}
        icon={faFileExport}
        onClick={onExportFiltered}
        disabled={!onExportFiltered}
      />
    </DropdownMenu>
  );
};
